import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tc_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Any completed mission/boss/assessment change refreshes the sidebar XP/level in place.
const PROGRESS_URL = /(\/complete|market-complete|\/assess\/(submit|reset)|\/trade\/pass|\/journal|\/titles\/display)/;
api.interceptors.response.use((r) => {
  if (r.config?.method === "post" && PROGRESS_URL.test(r.config.url || "")) window.dispatchEvent(new Event("tc:progress"));
  return r;
});

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
